import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)
/**
 * Note: 路由配置项
 * name:'router-name'             // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * meta : {
    keepAlive: true              // 如果设置为true，则会被 <keep-alive> 缓存 (默认 false)
    title: 'title'               // 设置该路由在页面顶部的Title
    index: '1'                   // 设置该路由页面切换是否左右滑动及权重，如不设页面不滑动  PS：功能暂时未启用
    hidden: true                 // 如果设置为true，显示底部菜单，如不设或者false，不显示
  }
 */
export const constantRoutes = [
  {
    path: '/',
    redirect: '/homesteadLogin'
  },
  {
    path: '/index',
    name: 'index',
    meta: {
      title: '主页',
      keepAlive: true
    },
    component: (resolve) => require(['@/views/index'], resolve)
  },
  {
    path: '/user',
    name: 'user',
    meta: {
      title: '个人中心',
    },
    component: (resolve) => require(['@/views/user/index'], resolve)
  },
  {
    path: '/accountSetting',
    name: 'accountSetting',
    meta: {
      title: '账户设置',
      hidden: true,
    },
    component: (resolve) => require(['@/views/user/accountSetting/index'], resolve)
  },
  {
    path: '/userInformation',
    name: 'userInformation',
    meta: {
      title: '资料修改',
      hidden: true,
    },
    component: (resolve) => require(['@/views/user/accountSetting/userInformation/userInformation'], resolve)
  },
  {
    path: '/passWordInformation',
    name: 'passWordInformation',
    meta: {
      title: '密码修改',
      hidden: true,
    },
    component: (resolve) => require(['@/views/user/accountSetting/passWordInformation/index'], resolve)
  },
  {
    path: '/phoneInformation',
    name: 'phoneInformation',
    meta: {
      title: '手机号修改',
      hidden: true,
    },
    component: (resolve) => require(['@/views/user/accountSetting/phoneInformation/index'], resolve)
  },
  {
    path: '/homesteadLogin',
    name: 'homesteadLogin',
    meta: {
      title: '登录页',
      hidden: true,
    },
    component: (resolve) => require(['@/views/homesteadLogin'], resolve)
  },
  {
    path: '/homesteadSurvey/index',
    name: 'homesteadIndex',
    meta: {
      title: '排班查看',
      hidden: true,
    },
    component: (resolve) => require(['@/views/homesteadSurvey/index'], resolve)
  },
  {
    path: '/homesteadSurvey/settle',
    name: 'homesteadSettle',
    meta: {
      title: '排班查看',
      hidden: true,
    },
    component: (resolve) => require(['@/views/homesteadSurvey/settle'], resolve)
  },
];


export default new Router({
  linkActiveClass: 'active',
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})



// WEBPACK FOOTER //
// ./src/router/index.js